import { combineReducers } from 'redux';

import loadingArraySlice from 'modules/global/reducers/loadingArraySlice';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import * as types from 'modules/releases/actionTypes';
import { DASHBOARD_SOURCE } from 'modules/releases/constants';

import creationModal from './creation-modal';
import details from './details';
import filters from './filters';
import noteCsvModal from './note-csv-modal';
import noteModal from './note-modal';
import releaseModal from './release-modal';

/**
 * @typedef {{
 *    filters: import('modules/releases/reducers/ui/filters').ReleasesFiltersReducer,
 *    data: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 *    loading: {
 *      patch: string[],
 *      delete: string[],
 *    }
 * }} ReleasesUIDashboardReducer
 */

/**
 * @typedef {{
 *  creationModal: import('./creation-modal').ReleaseUIModalCreationReducer,
 *  noteModal: import('./note-modal').ReleaseNoteModalReducer,
 *  dashboard: ReleasesUIDashboardReducer,
 *  details: import('./details').ReleasesUIDetailsReducer,
 * }} ReleasesUIReducer
 */

/**
 * @param {import("modules/global/generic.types").Action<unknown>} action
 * @returns {boolean}
 */
const dashboardPageActionMatcher = ({ meta = {} }) => meta.source === DASHBOARD_SOURCE;

const GENERIC_SLICE_CONFIG = {
  global: {
    selectId: entity => entity?.id ?? entity?.releaseId ?? entity,
  },
};

export default combineReducers({
  creationModal,
  releaseModal,
  noteModal,
  noteCsvModal,
  details,
  dashboard: combineReducers({
    filters,
    data: createSearchReducers(types.FETCH_RELEASES, {
      ids: {
        [types.CREATE_RELEASE_SUCCESS]: (state, { payload }) => [...state, payload.id],
        [types.DELETE_RELEASE_SUCCESS]: (state, { payload: releaseId }) => state.filter(id => id !== releaseId),
      },
      global: { matcher: dashboardPageActionMatcher, paginationSlice: true },
    }),
    loading: combineReducers({
      delete: loadingArraySlice(types.DELETE_RELEASE, GENERIC_SLICE_CONFIG),
      patch: loadingArraySlice(types.PATCH_RELEASE_STATE, GENERIC_SLICE_CONFIG),
    }),
  }),
});
